export { default } from './modal-surprise-card';
